<div class="profile-flex-container">
  <div class="profile-flex">
    <app-profile-sidebar activePage="user-profile"  class="z-2 profile-sidebar m-w-100" ></app-profile-sidebar>

    <div class="wrapper">
      <div class="tickets profile-wrapper-container" *ngIf="areTransactionsLoaded">    
        <div id="ticket-container">
          <ng-container *ngIf="nextEvents.length < 1">
            <p class="profile-description profile-title-mt">
              {{ "TICKETS.NO_TICKETS_PURCHASED" | translate }}
              <br/>
              <ng-container *ngIf="allEvents && allEvents.length > 0">{{ "TICKETS.SEE_NEXT_EVENTS" | translate }}</ng-container>
            </p>

            <app-events-list 
              [allEvents]="allEvents" 
              [isUserProfilePage]="true" 
              *ngIf="allEvents"
              >
            </app-events-list>
          </ng-container>

          <p *ngIf="nextEvents.length > 0 || previousEvents.length > 0" class="profile-title">
            {{ "PROFILE.YOUR_TICKETS" | translate }}
          </p>

          <ng-container *ngIf="nextEvents.length > 0">
            <p class="profile-title">{{ "PROFILE.NEXT_GAMES" | translate }}</p>
            <app-list-of-transactions [events]="nextEvents" class="ticket-container"></app-list-of-transactions>
          </ng-container>

          <ng-container *ngIf="previousEvents.length > 0">
            <p class="profile-title">{{ "PROFILE.PAST_GAMES" | translate }}</p>
            <app-list-of-transactions [events]="previousEvents" class="ticket-container previous-events"></app-list-of-transactions>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<app-notification *ngIf="showNotification" [bodyText]="bodyText | translate"></app-notification>